import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'pnx-button',
    templateUrl: './button.control.html'
})
export class ButtonControl {
    @Input() class = '';
    @Input() type = 'button'; 
    @Input() text = 'Submit'; 
    @Input() disabled = false;
    @Input() routerLink = '#';
    @Output() onClickEvent: EventEmitter<any> = new EventEmitter<any>();
}


// WEBPACK FOOTER //
// ./SignClient/app/shared/controls/button.control.ts